// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"8c6f0aaa7f9bad5c0e31","245":"a0780944dd53a9e25ccd","452":"946bdfa73791e80f7e7d","453":"824192a4f6c600fd3166"}[chunkId] + ".js";
};